// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'

// Internal Dependencies:
import VerseModal from './VerseModal'

class Verse extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			showModal: false,
			showNotice: false,
			noticeText: ''
		}

		this.state = state
	}

	showModal = () => {
		const { data } = this.props

		this.setState( {
			showModal: true
		} )
	}

	closeModal = () => {
		this.setState( {
			showModal: false
		} )
	}

	handleRecordingsClick = ( e ) => {
		e.preventDefault()
		e.stopPropagation()

		const number = e.currentTarget.getAttribute( 'data-number' )
		let recordingsText = 'recordings'
		let existsText = 'exist'

		if ( 1 == number ) {
			recordingsText = 'recording'
			existsText = 'exists'
		}

		const text = `${number} ${recordingsText} of this verse already ${existsText}`

		this.setState( {
			showNotice: true,
			noticeText: text
		} )

		setTimeout( () => {
			this.setState( {
				showNotice: false
			} )
		}, 3000 )
	}

	render() {
		const { data, simple, scheduledVersesData } = this.props

		if ( ! data ) {
			return null
		}

		const { showModal } = this.state
		let className = data.recordings_number ? '-verse has-recording' : '-verse'
		let recordButtonDisabled = null
		let scheduleButtonDisabled = data.recordings_number ? null : true
		let hasScheduleRecordings = false

		if ( data.scheduled_recordings && Object.keys( data.scheduled_recordings ).length ) {
			hasScheduleRecordings = true
			scheduleButtonDisabled = null
		} else {
			scheduleButtonDisabled = true
		}

		let recordingsTextFull = 'No one has recorded this verse yet.'

		if ( data.recordings_number ) {
			let recordingsText = 'recordings'
			let existsText = 'exist'

			if ( 1 == data.recordings_number ) {
				recordingsText = 'recording'
				existsText = 'exists'
			}

			recordingsTextFull = `${data.recordings_number} ${recordingsText} of this verse already ${existsText}.`
		}

		// Check time:
		const todayPlus9 = DateTime.local().plus( { days: 9 } )
		const todayPlus2 = DateTime.local().plus( { days: 2 } )
		const thisYear = DateTime.local().toFormat( 'y' )
		const verseDate = DateTime.fromFormat( data.date_year_month_day, 'y-MM-dd' )

		if ( verseDate > todayPlus2 ) {
			scheduleButtonDisabled = true
		}

		if ( verseDate < todayPlus9 ) {
			recordButtonDisabled = true
		}

		return (
			<div className={ className } onClick={ this.showModal }>
				<span className="-click">
					Click to view

					{ ( ! simple && verseDate <= todayPlus2 && hasScheduleRecordings ) &&
						<i className="icon-calendar"></i>
					}
				</span>

				{ ! simple &&
					<header>
						<h2>{ data.date_display }</h2>

						{ data.recordings_number &&
							<div className="-recorded" onClick={ this.handleRecordingsClick } data-number={ data.recordings_number }>
								<span>{ data.recordings_number }</span>
							</div>
						}
					</header>
				}

				<main>
					{ ! simple &&
						<div className="-intro">
							<p>
								Hi, I’m ______________ from ______________ , and I’m here to share our verse of the day from <span className="-ref">{ data.reference }</span>.
							</p>
						</div>
					}

					<div className="-verse-text">
						<p dangerouslySetInnerHTML={ { __html: data.verse } } />
					</div>

					{ ! simple &&
						<div className="-outro">
							<p>
								You’re listening to Faith FM.
							</p>
						</div>
					}
				</main>

				{ showModal &&
					<VerseModal
						handleCancel={ this.closeModal }
						>

						<div className="-buttons">
							<div>
								<div className="-button">
									<Link to={ `/votd/${data.date}` } className="button -small" disabled={ recordButtonDisabled }>Record</Link>
								</div>

								<div className="-text">
									{ recordButtonDisabled &&
										<p>This verse is too early to record and schedule - please choose a verse at least 10 days in the future.</p>
									||
										<p>{ recordingsTextFull }</p>
									}
								</div>
							</div>

							{ ! simple &&
								<div>
									<div className="-button">
										<Link to={ `/votd-schedule/${data.date_year_month_day}` } className="button -small" disabled={ scheduleButtonDisabled }>View Schedule</Link>
									</div>

									<div className="-text">
										{ verseDate > todayPlus2 &&
											<p>The schedule is only available two days ahead of time - please check again later.</p>
										|| ! hasScheduleRecordings &&
											<p>Schedule unavailable - No recordings exist for this day.</p>
										||
											<p>Click the button to view</p>
										}
									</div>
								</div>
							}
						</div>
					</VerseModal>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		scheduledVersesData: state.votd.scheduledVersesData
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Verse )
